(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/views/sportservice-tab-base.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/views/sportservice-tab-base.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};

  svs.statistics.views.SportserviceTabBase = Backbone.View.extend({
    initialize: function(options) {
      this.options = options;
      this.options.params = this.options.params || {};
      this.currentTab = options.params.currentTab;
    },

    render: function(calledByTabView) {
      if (!this.currentTab) {
        this.renderWithData && this.renderWithData();
        return this;
      }
      calledByTabView =
        calledByTabView && typeof calledByTabView === 'boolean'
          ? calledByTabView
          : false;
      var neededData = this.model ? this.neededData(this.currentTab) : false;
      if (this.$el && (!this.model && !calledByTabView)) {
        this.$el.html(svs.statistics.statistics.templates.nodata({}));
        return this;
      } else if (this.$el && (!this.model || !neededData)) {
        $('.js-loader-container').hide(); 
        this.$el.html(
          svs.statistics.statistics.templates.nodata({ renderEmpty: true })
        );
        this.loader = new svs.components.Loader(
          this.$el.find('.statistic-notice')
        );
        this.loader.show(); 
        return this;
      }
      this.renderWithData && this.renderWithData();
      return this;
    },

    neededData: function(currentTab) {
      var data = false;
      switch (currentTab) {
        case 'StatMatchEvents':
          data = this.model.get('events');
          break;
        case 'StatMatchStatistics':
          data =
            this.model.get('statistics') &&
            (this.options && this.options.params.matchId);
          break;
        case 'StatMatchLineup':
          data =
            this.model.get('awayTeam') !== undefined &&
            this.model.get('homeTeam') !== undefined;
          break;
        case 'StatGeneralTables':
          data = svs.utils.ns.isNamespace(
            'attributes.leagueTables',
            this.model
          );
          break;
        default:
          break;
      }
      return data;
    },

    onDestroy: function() {
      if (this.$el) {
        this.$el.empty();
      }
    }
  });
})(Backbone, _, svs);

 })(window);